export enum EAutomationType {
  AutoCompounding,
  AutoRebalancing,
  AutoExit,
}
